/**
 * 以 '***tag***' 此标记 为 待处理项(提醒后台进行修改) 处理完成后删除此标记
 */

import './utils/polyfill'
import Vue from 'vue'
import clone from 'clone'
import VueBus from 'vue-bus'
import './element-ui'
import App from './App'
import router from './router'
import store from './store'
// 标题的全局混合
import titleMixin from './utils/title-mixin'
// 有关权限判断及数据的全局混合
import roleMixin from './utils/role-mixin'

// 私有的全据变量
import global from './utils/global'

// 全局组件
import './utils/components'
// 全局的过滤器
import './utils/filter'

// deep clone
Vue.prototype.$clone = clone
// 在vue 原型上挂载私有的全局变量
Vue.prototype._global = global

Vue.config.productionTip = false

// 标题的全局混合
Vue.mixin(titleMixin)
// 有关权限判断及数据的全局混合
Vue.mixin(roleMixin)
// 全局总线
Vue.use(VueBus)

// 存储初始状态的state，退出登录后用于重置state
sessionStorage.setItem('initState', JSON.stringify(store.state))

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js